export function isNavSelected(navTo: string, pathname: string, search: string): boolean {
  if (navTo.includes("?")) {
    return `${pathname}${search}` === navTo;
  }
  if (navTo === "/") {
    return pathname === "/" && !new URLSearchParams(search).has("tier");
  }
  return pathname.startsWith(navTo);
}
